import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { selectedGoodieProductsSelector, formattedTotalPriceOfSelectedGoodieProductsSelector } from 'swag-client-common/redux/goodie-giveaway/selectors/goodie-giveaway-selection.selectors';
import { REMOVE_SELECTED_GOODIE_PRODUCT_POPUP } from 'swag-client-common/constants';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { formattedSelectedGiveawayBudgetSelector, isTotalOfSelectedProductsBiggerThanBudgetSelector, giveawayLinkRouteSelector, selectedGiveawayColorWithFallbackSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { GiveawayLandingGoodieSelectedProducts as Component } from './giveaway-landing-goodie-selected-products';
const totalPriceColorSelector = createSelector(selectedGiveawayColorWithFallbackSelector, isTotalOfSelectedProductsBiggerThanBudgetSelector, (giveawayColor, isInvalid) => {
  return isInvalid ? '' : giveawayColor;
});
const mapStateToProps = createStructuredSelector({
  selectedProductsTotal: formattedTotalPriceOfSelectedGoodieProductsSelector,
  budgetTotal: formattedSelectedGiveawayBudgetSelector,
  products: selectedGoodieProductsSelector,
  isInvalidTotal: isTotalOfSelectedProductsBiggerThanBudgetSelector,
  link: giveawayLinkRouteSelector,
  amountColor: totalPriceColorSelector,
  giveawayColor: selectedGiveawayColorWithFallbackSelector
});
const mapDispatchToProps = dispatch => ({
  onProductRemoveClick: (product, link) => {
    dispatch(showPopup({
      popup: REMOVE_SELECTED_GOODIE_PRODUCT_POPUP,
      product,
      link
    }));
  }
});
export const GiveawayLandingGoodieSelectedProducts = connect(mapStateToProps, mapDispatchToProps)(Component);